<div class="language-dropdown" (clickOutside)="closeLanguageMenu()" appClickOutside>
  <button class="btn btn-link btn-icon language-btn-link " [ngClass]="{ 'active' : showLanguageMenu === true }"
    (click)="toggleLanguageMenu()">
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"
      stroke="currentColor">
      <path
        d="M14 22.3334C18.6024 22.3334 22.3334 18.6025 22.3334 14.0001C22.3334 9.39771 18.6024 5.66675 14 5.66675C9.39765 5.66675 5.66669 9.39771 5.66669 14.0001C5.66669 18.6025 9.39765 22.3334 14 22.3334Z"
        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
      <path d="M5.66669 14H22.3334" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
      <path
        d="M14 5.66675C16.0844 7.94871 17.269 10.9101 17.3334 14.0001C17.269 17.0901 16.0844 20.0515 14 22.3334C11.9156 20.0515 10.7311 17.0901 10.6667 14.0001C10.7311 10.9101 11.9156 7.94871 14 5.66675V5.66675Z"
        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>
    <span class="selected-language">{{selectedLanguage}}</span>
  </button>
  <div class="menu">
    <div class="language-dropdown-container fadeIn" *ngIf="showLanguageMenu === true">
      <ul class="language-dropdown-menu">
        <li>
          <div class="dropdown-item" [ngClass]="{ 'active' : selectedLanguage === 'en' }"
            (click)="languageChanged('en')">English</div>
        </li>
        <li>
          <div class="dropdown-item" [ngClass]="{ 'active' : selectedLanguage === 'fr' }"
            (click)="languageChanged('fr')">Français</div>
        </li>
        <li>
          <div class="dropdown-item" [ngClass]="{ 'active' : selectedLanguage === 'de' }"
            (click)="languageChanged('de')">Deutsch</div>
        </li>
        <li>
          <div class="dropdown-item" [ngClass]="{ 'active' : selectedLanguage === 'it' }"
            (click)="languageChanged('it')">Italiano</div>
        </li>
      </ul>
    </div>
  </div>
</div>
